import dynamic from "next/dynamic";
import { Fragment } from "react";
import CompanyWrapper from "../../components/company/CompanyWrapper";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import SharedCompanyHeader from "../../components/shared/SharedHeader/SharedCompanyHeader/SharedCompanyHeader";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import { getCompanyWithoutRedux } from "../../redux/actions/company_action";

const Toolbar = dynamic(() => import("@mui/material/Toolbar"));
const SharedChat = dynamic(
  () => import("../../components/shared/SharedChat/SharedChat")
);
const SharedCollapsibleFooter = dynamic(
  () =>
    import(
      "../../components/shared/SharedCollapsibleFooter/SharedCollapsibleFooter"
    )
);

function CompanyProfile({ company }) {
  return (
    <Fragment>
      <SharedCompanyHeader company={company} />
      <ToResolveClassNameError>
        <SharedNavbar2 page="company-list-page" />
      </ToResolveClassNameError>
      <Toolbar
        sx={{
          "@media(min-width: 1280px)": {
            minHeight: "64px",
          },
          "@media(max-width: 1279px)": {
            minHeight: "52px",
          },
          "@media(max-width: 639px)": {
            minHeight: "60px",
          },
        }}
      />
      <CompanyWrapper company={company} />
      <ToResolveClassNameError>
        <SharedChat />
        <SharedCollapsibleFooter />
      </ToResolveClassNameError>
    </Fragment>
  );
}

export async function getStaticPaths() {
  let paths = [];

  return {
    paths: paths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }) {
  // Get static company
  let param = {
    companyId: params.id,
  };
  const company = await getCompanyWithoutRedux(param);

  if (company?.hide) {
    return {
      redirect: {
        permanent: false,
        destination: "/companies",
      },
      revalidate: 480,
    };
  }

  if (company?.companyNotFound) {
    return {
      notFound: true,
      revalidate: 480,
    };
  }

  return {
    props: {
      id: params.id,
      company: company,
    },
    revalidate: 480,
  };
}

export default CompanyProfile;
